var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinLocationMapSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-pin-location-map",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pin-location-map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#091DF2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.438 L3.938,12.906 L3.938,1.062 L0,-0.015 L0,11.438 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.506,8.005 C10.145,8.005 9.043,9.209 9.043,10.695 C9.043,11.079 9.119,11.442 9.25,11.774 L11.514,15.926 L13.759,11.774 C13.893,11.442 13.967,11.079 13.967,10.695 C13.967,9.209 12.864,8.005 11.506,8.005 L11.506,8.005 Z M11.5220204,12.046 C10.6924286,12.046 10.021,11.3749597 10.021,10.5455314 C10.021,9.7170403 10.6914082,9.046 11.5220204,9.046 C12.3495714,9.046 13.021,9.7170403 13.021,10.5455314 C13.021,11.3749597 12.3495714,12.046 11.5220204,12.046 L11.5220204,12.046 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.969 L11.031,0.041 L11.031,6.895 C11.187,6.875 11.343,6.849 11.506,6.849 C13.483,6.849 15.084,8.39 15.084,10.292 C15.084,10.784 14.976,11.248 14.783,11.674 L14.398,12.303 L16,13 L16,0.969 L16,0.969 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.926,10.292 C7.926,8.922 8.764,7.748 9.969,7.194 L9.969,0.166 L5.031,1.062 L5.031,12.906 L8.712,12.457 L8.227,11.674 C8.035,11.248 7.926,10.784 7.926,10.292 L7.926,10.292 Z",
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocationMapSvgrepoCom);
export default __webpack_public_path__ + "static/media/pin-location-map-svgrepo-com.08de4ac68ecf21494093721f0957a0c0.svg";
export { ForwardRef as ReactComponent };